$(document).ready(function () {
  $('.hamburger').click(function () {
    $('.hamburger').toggleClass('hamburger--active');
    $('.nav').toggleClass('nav--open');
    $('body').toggleClass('nav-on');
  });
  var fixBlock = $('.header');
  $(window).on('scroll load', function () {
    if ($(window).scrollTop() > 0) {
      fixBlock.addClass('fixed-header');
    } else {
      fixBlock.removeClass('fixed-header');
    }
  });
  var slider = $('.slider--plugins');

  if (slider.length !== 0) {
    slider.slick({
      infinite: true,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: true,
      speed: 20000,
      autoplaySpeed: 0,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplay: false,
          speed: 500,
          cssEase: 'ease'
        }
      }]
    });
  }
});